import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
var routes = [{
  path: '/promotion/allocation',
  component: function component() {
    return import('../app.vue');
  },
  children: [{
    name: '/',
    path: '/',
    redirect: {
      name: 'allotMain'
    }
  }, {
    name: 'allotFall',
    path: 'allotFall',
    component: function component() {
      return import('../pages/allotFall/index.vue');
    }
  }, {
    name: 'allotMain',
    path: 'allotMain',
    component: function component() {
      return import('../pages/allotMain/index.vue');
    }
  }, {
    name: 'allotSplitScreen',
    path: 'allotSplitScreen',
    component: function component() {
      return import('../pages/allotSplitScreen/index.vue');
    }
  }, {
    name: 'allotLanding',
    path: 'allotLanding',
    component: function component() {
      return import('../pages/allotLanding/allotLanding.vue');
    }
  }, {
    name: 'allotTrainCamp',
    path: 'allotTrainCamp',
    component: function component() {
      return import('../pages/allotTrainCamp/index.vue');
    }
  }, {
    name: 'allotPictureMuseum',
    path: 'allotPictureMuseum',
    component: function component() {
      return import('../pages/allotPictureMuseum/index.vue');
    }
  }]
}, {
  name: 'oldPage',
  path: '/promotion/allocation.html',
  component: function component() {
    return import('../pages/allotSplitScreen/index.vue');
  }
}];
var router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.hash) {
        return {
          selector: to.hash
        };
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    }
  }
});
router.beforeEach(function (to, from, next) {
  next();
});
export default router;